import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { logout } from '../../utils/apiClient';
import { SignInCard } from './SignInCard';

const useStyles = makeStyles(theme => ({
  card: {
    textAlign: 'center' as const,
  },
  message: {
    margin: theme.spacing(2, 0, 3),
  },
}));

/**
 * Shown to a signed-in user who belongs to no organization (the backend's 403
 * NO_ORGANIZATION, CB25SES-1807). It makes no API call, so it cannot loop;
 * signing out is the way to try another account.
 */
export function NoAccessPage() {
  const { t } = useTranslation('auth');
  const classes = useStyles();

  return (
    <SignInCard className={classes.card}>
      <Typography variant="h5">{t('noAccess.title')}</Typography>
      <Typography className={classes.message}>
        {t('noAccess.message')}
      </Typography>
      <Button variant="contained" color="primary" onClick={() => logout()}>
        {t('noAccess.signOut')}
      </Button>
    </SignInCard>
  );
}
